export default "__VITE_ASSET__CZP2NFzI__"